import { cva, type VariantProps } from 'class-variance-authority';
import { uiMarker, uiMarkerInternal, uiMarkerLayout } from './shared';

/**
 * LIST BESIDE ITS RECORD
 *
 * The inspections and trucks screens: a 400-wide list column on the left and
 * the record picked from it on the right, stacked below `lg`. Unlike
 * MasterDetail the list never narrows or slides away — the column is the
 * grouped list, flush, with every band and row drawing its own inset.
 *
 * `scroll` is for a screen that fits the shell's height (`Page fill="lg"`):
 * from `lg` up each column scrolls on its own and the heading, the tabs and
 * the list stay where they are. Without it the page scrolls as one.
 */
export const listDetailLayoutRecipe = cva(
  [uiMarker, uiMarkerLayout, 'flex w-full flex-col items-start lg:flex-row'],
  {
    variants: {
      scroll: { true: 'lg:min-h-0 lg:flex-1', false: '' },
    },
    defaultVariants: { scroll: false },
  }
);

export const listDetailLayoutListRecipe = cva(
  [uiMarkerInternal, 'flex w-full flex-col lg:w-[400px] lg:shrink-0'],
  {
    variants: {
      scroll: { true: 'lg:h-full lg:min-h-0 lg:overflow-y-auto', false: '' },
    },
    defaultVariants: { scroll: false },
  }
);

/** The record. 16 down from the tabs, the same as a TabsContent's own gap. */
export const listDetailLayoutDetailRecipe = cva(
  [uiMarkerInternal, 'w-full min-w-0 pt-4 lg:flex-1'],
  {
    variants: {
      scroll: {
        true: 'lg:h-full lg:min-h-0 lg:overflow-y-auto lg:overflow-x-hidden',
        false: '',
      },
    },
    defaultVariants: { scroll: false },
  }
);

export type ListDetailLayoutRecipeProps = VariantProps<
  typeof listDetailLayoutRecipe
>;
